var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"search-trigger",on:{"click":function($event){$event.preventDefault();_vm.toggle()}}},[_c('i',{staticClass:"fa fa-search fa-fw"})])}
var staticRenderFns = []

export { render, staticRenderFns }